import { useMemo } from 'react';
import { properties, roomMeta } from '../data';
import { formatPrice, formatShortDate, isStayAvailable, nightsBetween, nightsLabel, occupancyLabel } from '../utils';
import SearchForm from './SearchForm';

export default function RateListPage({ search, setSearch, onSearch, onHome, onBook }) {
  const nights = nightsBetween(search.checkIn, search.checkOut) || 1;
  const hasDates = Boolean(search.checkIn && search.checkOut);
  const guests = search.occupancy?.adults || 1;
  const rooms = useMemo(
    () => properties.filter((p) => (
      isStayAvailable(p, search.checkIn, search.checkOut)
      && roomMeta(p).sleeps >= guests
    )),
    [search.checkIn, search.checkOut, guests],
  );

  return (
    <div className="page">
      <div className="wrap">
        <div className="crumbs">
          <button onClick={onHome}>Home</button>
          <span>›</span>
          <span>Kaya Serene Villa</span>
          <span>›</span>
          <span>Available stays</span>
        </div>

        <div className="stay-bar">
          <div>
            <p className="stay-bar-kicker">Your stay</p>
            <h1>Available stays</h1>
            <p>
              {hasDates
                ? `${formatShortDate(search.checkIn)} – ${formatShortDate(search.checkOut)} · ${nightsLabel(nights)} · ${occupancyLabel(search.occupancy)}`
                : 'Choose dates, then book a stay'}
            </p>
          </div>
        </div>

        <SearchForm
          className="results-search"
          search={search}
          setSearch={setSearch}
          onSearch={onSearch}
        />

        {rooms.length === 0 && (
          <p className="results-empty">No rooms are free for these dates or this party size. Try another stay period.</p>
        )}

        {rooms.map((room) => {
          const meta = roomMeta(room);
          return (
            <article key={room.id} className="room-block">
              <div className="room-block-main">
                <img src={room.images[0]} alt="" />
                <div>
                  <h2>{room.name}</h2>
                  <p className="result-loc">{meta.beds} · Sleeps {meta.sleeps}</p>
                  <p>{room.description}</p>
                  <div className="amenity-row">
                    {room.amenities.map((a) => <span className="chip" key={a}>{a}</span>)}
                  </div>
                  <div className="room-block-actions">
                    <button
                      type="button"
                      className="see-btn"
                      onClick={() => onBook(room)}
                    >
                      Book now
                    </button>
                    <span className="price-note">{formatPrice(room.price)} / night</span>
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
